import {
    investmentOfferCities,
    InvestmentOfferCitySlug,
    investmentOfferHolidayTypes,
    investmentOfferSpainCities,
    InvestmentOfferSubCategory,
    InvestmentOfferTypeSlug
} from "../../constants/investment_offer_constants";

export const getInvestmentOffersSubCategoryOptions = (investmentOfferType: InvestmentOfferTypeSlug): {label: string; value: InvestmentOfferSubCategory}[] => {
    switch (investmentOfferType) {
        case InvestmentOfferTypeSlug.HOLIDAY:
            return investmentOfferHolidayTypes.map((type) => ({label: type.name, value: type.slug}));
        case InvestmentOfferTypeSlug.CONDOHOTEL:
        case InvestmentOfferTypeSlug.FOR_RENT:
            return [...investmentOfferHolidayTypes, ...investmentOfferCities].map((type) => ({label: type.name, value: type.slug}));
        case InvestmentOfferTypeSlug.ABROAD:
            return investmentOfferSpainCities.map((type) => ({label: type.name, value: type.slug}));
        default:
            return [{label: "Wszędzie", value: InvestmentOfferCitySlug.All}].concat(
                investmentOfferCities.map((type) => ({label: type.name, value: type.slug}))
            );
    }
};
import {
    investmentOfferCities,
    InvestmentOfferCitySlug,
    investmentOfferHolidayTypes,
    investmentOfferSpainCities,
    InvestmentOfferSubCategory,
    InvestmentOfferTypeSlug
} from "../../constants/investment_offer_constants";

export const getInvestmentOffersSubCategoryOptions = (investmentOfferType: InvestmentOfferTypeSlug): {label: string; value: InvestmentOfferSubCategory}[] => {
    switch (investmentOfferType) {
        case InvestmentOfferTypeSlug.HOLIDAY:
            return investmentOfferHolidayTypes.map((type) => ({label: type.name, value: type.slug}));
        case InvestmentOfferTypeSlug.CONDOHOTEL:
        case InvestmentOfferTypeSlug.FOR_RENT:
            return [...investmentOfferHolidayTypes, ...investmentOfferCities].map((type) => ({label: type.name, value: type.slug}));
        case InvestmentOfferTypeSlug.ABROAD:
            return investmentOfferSpainCities.map((type) => ({label: type.name, value: type.slug}));
        default:
            return [{label: "Wszędzie", value: InvestmentOfferCitySlug.All}].concat(
                investmentOfferCities.map((type) => ({label: type.name, value: type.slug}))
            );
    }
};
